import { render, staticRenderFns } from "./admin-billing-one-organization.vue?vue&type=template&id=38bb2178&scoped=true&"
import script from "./admin-billing-one-organization.vue?vue&type=script&lang=js&"
export * from "./admin-billing-one-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb2178",
  null
  
)

export default component.exports